<footer
  class="m-auto w-screen xs:max-w-screen-xs sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl xxl:max-w-screen-xxl"
>
  <div class="mx-auto w-full xl:max-w-screen-xxl p-4 py-6 lg:py-8">
    <div
      class="flex flex-col md:gap-12 text-center md:text-left md:flex-row md:justify-between"
      dir="ltr"
    >
      <div class="mb-6 md:mb-0 min-w-[10rem] md:w-[25rem]">
        <div class="max-w-screen-md text-center md:text-left">
          <div class="flex flex-col md:ltr:text-left md:rtl:text-right">
            <h2
              class="text-black dark:text-white w-full text-md text-3xl font-semibold md:text-xl mb-2"
            >
              {{ 'FOOTER.SUBSCRIPTION.TITLE' | translate }}
            </h2>
            <p
              for="email-address-icon"
              class="w-full mb-2 text-md md:text-sm font-medium text-gray-700 dark:text-gray-400"
            >
              {{ 'FOOTER.SUBSCRIPTION.DESCRIPTION' | translate }}
            </p>
          </div>
          <form
              [formGroup]="subscriptionForm"
              (ngSubmit)="onFormSubmit()"
            >
              <div
                class="items-center mx-auto mb-3 space-y-4 max-w-screen-sm sm:flex sm:space-y-0 rtl:flex-row-reverse"
              >
              @if(successfullySubscribed | async){
                <div class="flex flex-col w-full">
                  <div
                  class="flex w-full justify-center items-center p-3 text-sm text-green-800 border border-green-300 rounded-l-lg dark:bg-gray-800 dark:text-green-400 dark:border-green-800"
                  role="alert">
                    <div>
                      {{ 'FOOTER.SUBSCRIPTION.SUCCESSFULLY-SUBSCRIBED' | translate }}
                    </div>
                  </div>
                </div>
              } @else {
                <div class="relative w-full">
                  <label
                    for="email"
                    class="hidden mb-2 text-sm font-medium dark:text-gray-300"
                    >Email address</label
                  >
                  <div
                    class="flex absolute inset-y-0 rtl:right-1 left-0 items-center ltr:pl-3 rtl:pr-3 pointer-events-none"
                  >
                    <ng-icon
                      name="bootstrapMailbox"
                      class="text-gray-600 dark:text-neutral-400"
                    ></ng-icon>
                  </div>
                  <input
                    dir="ltr"
                    formControlName="email"
                    [ngClass]="{'border-y border-l border-red-500': invalidEmail,
                                'border border-gray-300 dark:border-gray-600': !invalidEmail
                    }"
                    class="block p-3 ltr:pl-10 rtl:pr-10 rtl:text-left rtl:ltr w-full text-sm bg-gray-50 rounded-lg  sm:rounded-none sm:rounded-l-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700  dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 text-left"
                    placeholder="{{ 'FOOTER.SUBSCRIPTION.EMAIL' | translate }}"
                    type="email"
                    id="email"
                    required=""
                  />
                </div>
                }
                <div>
                  <button
                    type="submit"
                    [disabled]="successfullySubscribed | async"
                    class="py-3 px-5 w-full text-sm font-medium text-center text-white rounded-lg border cursor-pointer bg-blue-700 border-blue-600 sm:rounded-none sm:rounded-r-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    {{ 'FOOTER.SUBSCRIPTION.SUBSCRIBE' | translate }}
                  </button>
                </div>
              </div>
              <div *ngIf="invalidEmail">
                <div
                  class="flex items-center p-2 text-sm text-red-800 border border-red-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-red-400 dark:border-red-800"
                  role="alert"
                >
                  <img
                    src="assets/icons/info-red.svg"
                    class="flex-shrink-0 inline w-4 h-4 me-3"
                    aria-hidden="true"
                    alt="Almanjobs logo"
                  />
                  <div>
                    {{ 'FOOTER.SUBSCRIPTION.EMAIL-RULE' | translate }}
                  </div>
                </div>
              </div>
          </form>
        </div>
      </div>
      <div
        class="grid grid-cols-1 sm:grid-cols-3 gap-8 items-baseline text-center sm:gap-6 sm:rtl:text-right sm:ltr:text-left p-4"
        dir="ltr"
      >
        <div>
          <h2
            class="mb-6 text-sm font-semibold uppercase dark:text-white"
          >
            {{ 'FOOTER.MAIN.TITLE' | translate }}
          </h2>
          <ul class="text-gray-500 dark:text-gray-400 font-medium">
            <li class="mb-1">
              <a [routerLink]="['/']" class="hover:underline">
                {{ 'FOOTER.MAIN.HOME' | translate }}
              </a>
            </li>
            <li class="mb-1">
              <a
                [routerLink]="['about-us']"
                aria-label="Learn more about our team and mission"
                class="hover:underline">
                {{ 'FOOTER.MAIN.ABOUT-US' | translate }}
              </a>
            </li>
            <li class="mb-1">
              <a [routerLink]="['faqs']" class="hover:underline">
                {{ 'FOOTER.MAIN.FAQS' | translate }}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h2
            class="mb-6 text-sm font-semibold uppercase dark:text-white"
          >
            {{ 'FOOTER.CAREERS.TITLE' | translate }}
          </h2>
          <ul class="text-gray-500 dark:text-gray-400 font-medium">
            <li class="mb-1">
              <a [routerLink]="['jobs']" class="hover:underline">
                {{ 'FOOTER.CAREERS.OPENINGS' | translate }}
              </a>
            </li>
            <li class="mb-1">
              <a [routerLink]="['employees']" class="hover:underline">
                {{ 'FOOTER.CAREERS.EMPLOYEE' | translate }}
              </a>
            </li>
            <li class="mb-1">
              <a [routerLink]="['employers']" class="hover:underline">
                {{ 'FOOTER.CAREERS.EMPLOYER' | translate }}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h2
            class="mb-6 text-sm font-semibold uppercase dark:text-white"
          >
            {{ 'FOOTER.LEGAL-MATTERS.TITLE' | translate }}
          </h2>
          <ul class="text-gray-500 dark:text-gray-400 font-medium">
            <li class="mb-1">
              <a
                [routerLink]="['terms-and-conditions']"
                class="hover:underline"
              >
                {{ 'FOOTER.LEGAL-MATTERS.TERMS-AND-CONDITIONS' | translate }}
              </a>
            </li>
            <li class="mb-1">
              <a [routerLink]="['privacy-policies']" class="hover:underline">
                {{ 'FOOTER.LEGAL-MATTERS.PRIVACY-POLICIES' | translate }}
              </a>
            </li>
            <li class="mb-1">
              <a [routerLink]="['imprint']" class="hover:underline">
                {{ 'FOOTER.LEGAL-MATTERS.IMPRINT' | translate }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <hr class="my-6 border-gray-200 sm:mx-auto dark:border-gray-700 lg:my-8" />
    <div
      class="flex flex-col md:flex-row items-center justify-between text-center"
    >
      <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">
        &copy; {{ currentYear }}
        <a href="https://almanjobs.com" class="hover:underline"
          >Almanjobs&trade;</a
        >. All Rights Reserved.
      </span>
      <div class="flex mt-4 sm:justify-center md:mt-0">
        <a
          href="https://twitter.com/thealmanjobs"
          target="_blank"
          class="text-gray-500 hover:text-gray-900 dark:hover:text-white mx-2"
        >
          <ng-icon name="bootstrapTwitter"></ng-icon>
          <span class="sr-only">Twitter page</span>
        </a>
        <a
          href="https://www.instagram.com/thealmanjobs"
          target="_blank"
          class="text-gray-500 hover:text-gray-900 dark:hover:text-white mx-2"
        >
          <ng-icon name="bootstrapInstagram"></ng-icon>
          <span class="sr-only">Instagram page</span>
        </a>
        <a
          href="https://facebook.com"
          target="_blank"
          class="text-gray-500 hover:text-gray-900 dark:hover:text-white mx-2"
        >
          <ng-icon name="bootstrapFacebook"></ng-icon>
          <span class="sr-only">Facebook page</span>
        </a>
      </div>
    </div>
  </div>
</footer>
